import { get, isString } from 'lodash';

class HttpError extends Error {
  // @ts-ignore
  constructor(httpResponse) {
    const serviceResponse = get(httpResponse, 'response.data', httpResponse);
    const message = HttpError.getErrorMessage(httpResponse);
    //  const httpData = HttpError.getHttpResponseLogData(httpResponse);

    console.error('HTTP Error:', {
      message,
      status: httpResponse.status,
      data: serviceResponse.data,
      url: get(httpResponse, 'config.url'),
      method: httpResponse.config.method.toUpperCase(),
    });

    console.error('[ HTTP Error ] service response', serviceResponse);

    super(message);
  }

  private static getErrorMessage(httpResponse): string {
    const serviceResponse = get(httpResponse, 'response.data', httpResponse);

    if (isString(serviceResponse)) {
      return serviceResponse;
    }

    const message =
      get(serviceResponse, 'message') || get(serviceResponse, 'error.message');

    return message || serviceResponse.error || httpResponse.message;
  }

  private static getHttpResponseLogData = (httpClientResponse) => {
    return {
      status: get(httpClientResponse, 'response.status'),
      service: get(httpClientResponse, 'config.serviceName'),
      http: {
        headers: get(httpClientResponse, 'request.headers'),
        params: get(httpClientResponse, 'config.params'),
        body: get(httpClientResponse, 'config.data'),
        url: get(httpClientResponse, 'request.path'),
        resource: get(httpClientResponse, 'data.name'),
        meta: get(httpClientResponse, 'data.meta'),
        method: get(httpClientResponse, 'config.method'),
      },
    };
  };
}

export default HttpError;
